// A schedule in words, and when it next goes (Back office sweep, Oct 2026: Schedules).
// Days of the week count from Monday (0), as `report_scheduler.py` keeps them; times are the
// venue's wall clock, which for the back office is the browser's.

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const QUARTER_MONTHS = [0, 3, 6, 9];

const ordinal = (n) => {
  const tens = n % 100;
  if (tens >= 11 && tens <= 13) return `${n}th`;
  return `${n}${{ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th'}`;
};

// "alex@…", "alex@… and priya@…", "alex@… and 2 others"
export function toWhom(recipients = []) {
  if (!recipients.length) return null;
  if (recipients.length === 1) return recipients[0];
  if (recipients.length === 2) return `${recipients[0]} and ${recipients[1]}`;
  return `${recipients[0]} and ${recipients.length - 1} others`;
}

// "Every Monday at 08:00", "The 1st of each month at 09:00"
export function whenWords(s) {
  const at = `at ${s.time_hhmm || '08:00'}`;
  const dom = ordinal(s.day_of_month || 1);
  if (s.frequency === 'daily') return `Every day ${at}`;
  if (s.frequency === 'weekly') return `Every ${DAYS[s.day_of_week ?? 0] || 'Monday'} ${at}`;
  if (s.frequency === 'monthly') return `The ${dom} of each month ${at}`;
  return `The ${dom} of January, April, July and October ${at}`;
}

const isADay = (s, d) => {
  if (s.frequency === 'daily') return true;
  if (s.frequency === 'weekly') return (d.getDay() + 6) % 7 === (s.day_of_week ?? 0);
  if (d.getDate() !== (s.day_of_month || 1)) return false;
  return s.frequency === 'monthly' || QUARTER_MONTHS.includes(d.getMonth());
};

// The next time it goes, or null when it's paused.
export function nextRun(s, now = new Date()) {
  if (!s.enabled) return null;
  const [h, m] = (s.time_hhmm || '08:00').split(':').map(Number);
  for (let i = 0; i <= 92; i += 1) {
    const at = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, h, m);
    if (at > now && isADay(s, at)) return at;
  }
  return null;
}

// "Mon 26 Oct, 08:00"
export function shortWhen(at) {
  if (!at) return '';
  const day = at.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).replace(',', '');
  return `${day}, ${String(at.getHours()).padStart(2, '0')}:${String(at.getMinutes()).padStart(2, '0')}`;
}
